import type * as sanitizeModule from "./sanitizeUrlPathSegment";
import { LazyAction, LazyModule } from "owa-bundling-light";

const lazyModule: LazyModule<typeof sanitizeModule> = new LazyModule<typeof sanitizeModule>(() => import(/* webpackChunkName: "SanitizeUrlPathSegment" */ "./sanitizeUrlPathSegment"), { name: "SanitizeUrlPathSegment" });

export const lazySanitizeUserProvidedPathSegment: LazyAction<typeof sanitizeModule.sanitizeUserProvidedPathSegment, typeof lazyModule> = new LazyAction(lazyModule, m => m.sanitizeUserProvidedPathSegment);
